module.exports = __webpack_public_path__ + "static/media/about.22271dcd.webp";